/* tslint:disable */

import * as models from '../models';

/* pre-prepared guards for build in complex types */

function _isBlob(arg: any): arg is Blob {
  return arg != null && typeof arg.size === 'number' && typeof arg.type === 'string' && typeof arg.slice === 'function';
}

export function isFile(arg: any): arg is File {
return arg != null && typeof arg.lastModified === 'number' && typeof arg.name === 'string' && _isBlob(arg);
}

/* generated type guards */

export function isAddressDto(arg: any): arg is models.AddressDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // city?: string
    ( typeof arg.city === 'undefined' || typeof arg.city === 'string' ) &&
    // country?: string
    ( typeof arg.country === 'undefined' || typeof arg.country === 'string' ) &&
    // door?: string
    ( typeof arg.door === 'undefined' || typeof arg.door === 'string' ) &&
    // floor?: string
    ( typeof arg.floor === 'undefined' || typeof arg.floor === 'string' ) &&
    // houseNumber?: string
    ( typeof arg.houseNumber === 'undefined' || typeof arg.houseNumber === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // phoneNumber?: string
    ( typeof arg.phoneNumber === 'undefined' || typeof arg.phoneNumber === 'string' ) &&
    // street?: string
    ( typeof arg.street === 'undefined' || typeof arg.street === 'string' ) &&
    // zip?: string
    ( typeof arg.zip === 'undefined' || typeof arg.zip === 'string' ) &&

  true
  );
  }

export function isAgentDto(arg: any): arg is models.AgentDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // email?: string
    ( typeof arg.email === 'undefined' || typeof arg.email === 'string' ) &&
    // frameContractId?: number
    ( typeof arg.frameContractId === 'undefined' || typeof arg.frameContractId === 'number' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&

  true
  );
  }

export function isCaptchaValidationResponseDto(arg: any): arg is models.CaptchaValidationResponseDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // errorCode?: number
    ( typeof arg.errorCode === 'undefined' || typeof arg.errorCode === 'number' ) &&
    // errorMessage?: string
    ( typeof arg.errorMessage === 'undefined' || typeof arg.errorMessage === 'string' ) &&
    // logId: number
    ( typeof arg.logId === 'number' ) &&
    // success: number
    ( typeof arg.success === 'number' ) &&
    // timeExpired: string
    ( typeof arg.timeExpired === 'string' ) &&

  true
  );
  }

export function isCentralZIPDto(arg: any): arg is models.CentralZIPDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // city?: string
    ( typeof arg.city === 'undefined' || typeof arg.city === 'string' ) &&
    // streetName?: string
    ( typeof arg.streetName === 'undefined' || typeof arg.streetName === 'string' ) &&
    // streetType?: string
    ( typeof arg.streetType === 'undefined' || typeof arg.streetType === 'string' ) &&
    // zip?: number
    ( typeof arg.zip === 'undefined' || typeof arg.zip === 'number' ) &&

  true
  );
  }

export function isCirRoleItemDto(arg: any): arg is models.CirRoleItemDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // roleId?: number
    ( typeof arg.roleId === 'undefined' || typeof arg.roleId === 'number' ) &&
    // roleName?: string
    ( typeof arg.roleName === 'undefined' || typeof arg.roleName === 'string' ) &&

  true
  );
  }

export function isCirUserDto(arg: any): arg is models.CirUserDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // email?: string
    ( typeof arg.email === 'undefined' || typeof arg.email === 'string' ) &&
    // firstName?: string
    ( typeof arg.firstName === 'undefined' || typeof arg.firstName === 'string' ) &&
    // isActive?: boolean
    ( typeof arg.isActive === 'undefined' || typeof arg.isActive === 'boolean' ) &&
    // lastName?: string
    ( typeof arg.lastName === 'undefined' || typeof arg.lastName === 'string' ) &&
    // roleList?: CirRoleItemDto[]
    ( typeof arg.roleList === 'undefined' || (Array.isArray(arg.roleList) && arg.roleList.every((item: unknown) => isCirRoleItemDto(item))) ) &&
    // userId?: number
    ( typeof arg.userId === 'undefined' || typeof arg.userId === 'number' ) &&

  true
  );
  }

export function isCodeModelDto(arg: any): arg is models.CodeModelDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // codeText?: string
    ( typeof arg.codeText === 'undefined' || typeof arg.codeText === 'string' ) &&
    // generatedAccessToken?: string
    ( typeof arg.generatedAccessToken === 'undefined' || typeof arg.generatedAccessToken === 'string' ) &&

  true
  );
  }

export function isConfigDto(arg: any): arg is models.ConfigDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // description?: string
    ( typeof arg.description === 'undefined' || typeof arg.description === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // location?: string
    ( typeof arg.location === 'undefined' || typeof arg.location === 'string' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // type?: string
    ( typeof arg.type === 'undefined' || typeof arg.type === 'string' ) &&
    // value?: string
    ( typeof arg.value === 'undefined' || typeof arg.value === 'string' ) &&

  true
  );
  }

export function isContractDto(arg: any): arg is models.ContractDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // administrationGroup?: CTAdministrationGroupDto
    ( typeof arg.administrationGroup === 'undefined' || isCTAdministrationGroupDto(arg.administrationGroup) ) &&
    // agentEmail?: string
    ( typeof arg.agentEmail === 'undefined' || typeof arg.agentEmail === 'string' ) &&
    // agentName?: string
    ( typeof arg.agentName === 'undefined' || typeof arg.agentName === 'string' ) &&
    // brokerID?: string
    ( typeof arg.brokerID === 'undefined' || typeof arg.brokerID === 'string' ) &&
    // createdBy?: string
    ( typeof arg.createdBy === 'undefined' || typeof arg.createdBy === 'string' ) &&
    // creationDate?: string
    ( typeof arg.creationDate === 'undefined' || typeof arg.creationDate === 'string' ) &&
    // deletionEffectDate?: string
    ( typeof arg.deletionEffectDate === 'undefined' || typeof arg.deletionEffectDate === 'string' ) &&
    // hasInsuredPersonQuantityDifference?: boolean
    ( typeof arg.hasInsuredPersonQuantityDifference === 'undefined' || typeof arg.hasInsuredPersonQuantityDifference === 'boolean' ) &&
    // healthServiceAdmin?: string
    ( typeof arg.healthServiceAdmin === 'undefined' || typeof arg.healthServiceAdmin === 'string' ) &&
    // healthServiceEndDate?: string
    ( typeof arg.healthServiceEndDate === 'undefined' || typeof arg.healthServiceEndDate === 'string' ) &&
    // hrAdministrators?: HrAdminContractDto[]
    ( typeof arg.hrAdministrators === 'undefined' || (Array.isArray(arg.hrAdministrators) && arg.hrAdministrators.every((item: unknown) => isHrAdminContractDto(item))) ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // indexationData?: IndexationDataDto
    ( typeof arg.indexationData === 'undefined' || isIndexationDataDto(arg.indexationData) ) &&
    // isActive?: boolean
    ( typeof arg.isActive === 'undefined' || typeof arg.isActive === 'boolean' ) &&
    // isFitpuli?: boolean
    ( typeof arg.isFitpuli === 'undefined' || typeof arg.isFitpuli === 'boolean' ) &&
    // isNaturalPerson?: boolean
    ( typeof arg.isNaturalPerson === 'undefined' || typeof arg.isNaturalPerson === 'boolean' ) &&
    // koopCode?: string
    ( typeof arg.koopCode === 'undefined' || typeof arg.koopCode === 'string' ) &&
    // koopFrameContractID?: string
    ( typeof arg.koopFrameContractID === 'undefined' || typeof arg.koopFrameContractID === 'string' ) &&
    // koopPartnerID?: number
    ( typeof arg.koopPartnerID === 'undefined' || typeof arg.koopPartnerID === 'number' ) &&
    // koopProductID?: number
    ( typeof arg.koopProductID === 'undefined' || typeof arg.koopProductID === 'number' ) &&
    // koopStateID?: string
    ( typeof arg.koopStateID === 'undefined' || typeof arg.koopStateID === 'string' ) &&
    // lastInsuredDataTransferDate?: string
    ( typeof arg.lastInsuredDataTransferDate === 'undefined' || typeof arg.lastInsuredDataTransferDate === 'string' ) &&
    // lastModifiedDate?: string
    ( typeof arg.lastModifiedDate === 'undefined' || typeof arg.lastModifiedDate === 'string' ) &&
    // lastUploadDate?: string
    ( typeof arg.lastUploadDate === 'undefined' || typeof arg.lastUploadDate === 'string' ) &&
    // lastUploadProcessedDate?: string
    ( typeof arg.lastUploadProcessedDate === 'undefined' || typeof arg.lastUploadProcessedDate === 'string' ) &&
    // netOfferUploadID?: number
    ( typeof arg.netOfferUploadID === 'undefined' || typeof arg.netOfferUploadID === 'number' ) &&
    // offerNumber?: string
    ( typeof arg.offerNumber === 'undefined' || typeof arg.offerNumber === 'string' ) &&
    // paymentEndDate?: string
    ( typeof arg.paymentEndDate === 'undefined' || typeof arg.paymentEndDate === 'string' ) &&
    // paymentStartDate?: string
    ( typeof arg.paymentStartDate === 'undefined' || typeof arg.paymentStartDate === 'string' ) &&
    // person?: PersonDto
    ( typeof arg.person === 'undefined' || isPersonDto(arg.person) ) &&
    // productMarketingName?: string
    ( typeof arg.productMarketingName === 'undefined' || typeof arg.productMarketingName === 'string' ) &&
    // productType?: CTProductTypeDto
    ( typeof arg.productType === 'undefined' || isCTProductTypeDto(arg.productType) ) &&
    // riskEndDate?: string
    ( typeof arg.riskEndDate === 'undefined' || typeof arg.riskEndDate === 'string' ) &&
    // riskStartDate?: string
    ( typeof arg.riskStartDate === 'undefined' || typeof arg.riskStartDate === 'string' ) &&
    // stateID?: CTStateDto
    ( typeof arg.stateID === 'undefined' || isCTStateDto(arg.stateID) ) &&
    // subContracts?: SubContractDto[]
    ( typeof arg.subContracts === 'undefined' || (Array.isArray(arg.subContracts) && arg.subContracts.every((item: unknown) => isSubContractDto(item))) ) &&

  true
  );
  }

export function isContractProcessingDataDto(arg: any): arg is models.ContractProcessingDataDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // lastInsuredDataTransferDate?: string
    ( typeof arg.lastInsuredDataTransferDate === 'undefined' || typeof arg.lastInsuredDataTransferDate === 'string' ) &&
    // lastModifiedDate?: string
    ( typeof arg.lastModifiedDate === 'undefined' || typeof arg.lastModifiedDate === 'string' ) &&
    // lastUploadDate?: string
    ( typeof arg.lastUploadDate === 'undefined' || typeof arg.lastUploadDate === 'string' ) &&
    // lastUploadProcessedDate?: string
    ( typeof arg.lastUploadProcessedDate === 'undefined' || typeof arg.lastUploadProcessedDate === 'string' ) &&

  true
  );
  }

export function isContractSearchListItemDto(arg: any): arg is models.ContractSearchListItemDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // contractOfferNumber?: string
    ( typeof arg.contractOfferNumber === 'undefined' || typeof arg.contractOfferNumber === 'string' ) &&
    // contractorName?: string
    ( typeof arg.contractorName === 'undefined' || typeof arg.contractorName === 'string' ) &&
    // hasInsuredPersonQuantityDifference?: boolean
    ( typeof arg.hasInsuredPersonQuantityDifference === 'undefined' || typeof arg.hasInsuredPersonQuantityDifference === 'boolean' ) &&
    // hrAdminData?: HrAdminContractDto[]
    ( typeof arg.hrAdminData === 'undefined' || (Array.isArray(arg.hrAdminData) && arg.hrAdminData.every((item: unknown) => isHrAdminContractDto(item))) ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // isActive?: boolean
    ( typeof arg.isActive === 'undefined' || typeof arg.isActive === 'boolean' ) &&
    // koopFrameContractID?: string
    ( typeof arg.koopFrameContractID === 'undefined' || typeof arg.koopFrameContractID === 'string' ) &&
    // productType?: CTProductTypeDto
    ( typeof arg.productType === 'undefined' || isCTProductTypeDto(arg.productType) ) &&
    // state?: CTStateDto
    ( typeof arg.state === 'undefined' || isCTStateDto(arg.state) ) &&

  true
  );
  }

export function isContractsInsurantsUploadDto(arg: any): arg is models.ContractsInsurantsUploadDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // contractId?: number
    ( typeof arg.contractId === 'undefined' || typeof arg.contractId === 'number' ) &&
    // contractNumber?: string
    ( typeof arg.contractNumber === 'undefined' || typeof arg.contractNumber === 'string' ) &&
    // file?: FileDto
    ( typeof arg.file === 'undefined' || isFileDto(arg.file) ) &&

  true
  );
  }

export function isContractToContractDto(arg: any): arg is models.ContractToContractDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // activeContractId: number
    ( typeof arg.activeContractId === 'number' ) &&
    // activeKoopFrameContractId?: string
    ( typeof arg.activeKoopFrameContractId === 'undefined' || typeof arg.activeKoopFrameContractId === 'string' ) &&
    // id?: number
    ( typeof arg.id === 'undefined' || typeof arg.id === 'number' ) &&
    // passiveKoopFrameContractId?: string
    ( typeof arg.passiveKoopFrameContractId === 'undefined' || typeof arg.passiveKoopFrameContractId === 'string' ) &&

  true
  );
  }

export function isCTAddressTypeDto(arg: any): arg is models.CTAddressTypeDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // description?: string
    ( typeof arg.description === 'undefined' || typeof arg.description === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // koopID?: string
    ( typeof arg.koopID === 'undefined' || typeof arg.koopID === 'string' ) &&
    // koopName?: string
    ( typeof arg.koopName === 'undefined' || typeof arg.koopName === 'string' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // netOfferPartnerTypeID?: number
    ( typeof arg.netOfferPartnerTypeID === 'undefined' || typeof arg.netOfferPartnerTypeID === 'number' ) &&
    // sID?: string
    ( typeof arg.sID === 'undefined' || typeof arg.sID === 'string' ) &&
    // validFrom?: string
    ( typeof arg.validFrom === 'undefined' || typeof arg.validFrom === 'string' ) &&
    // validTo?: string
    ( typeof arg.validTo === 'undefined' || typeof arg.validTo === 'string' ) &&

  true
  );
  }

export function isCTAdministrationGroupDto(arg: any): arg is models.CTAdministrationGroupDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // code?: string
    ( typeof arg.code === 'undefined' || typeof arg.code === 'string' ) &&
    // createdBy?: string
    ( typeof arg.createdBy === 'undefined' || typeof arg.createdBy === 'string' ) &&
    // creationDate?: string
    ( typeof arg.creationDate === 'undefined' || typeof arg.creationDate === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&

  true
  );
  }

export function isCTBaseCodeTableDto(arg: any): arg is models.CTBaseCodeTableDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // description?: string
    ( typeof arg.description === 'undefined' || typeof arg.description === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // isActive?: boolean
    ( typeof arg.isActive === 'undefined' || typeof arg.isActive === 'boolean' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // sID?: string
    ( typeof arg.sID === 'undefined' || typeof arg.sID === 'string' ) &&
    // validFrom?: string
    ( typeof arg.validFrom === 'undefined' || typeof arg.validFrom === 'string' ) &&
    // validTo?: string
    ( typeof arg.validTo === 'undefined' || typeof arg.validTo === 'string' ) &&

  true
  );
  }

export function isCTCustomizationDto(arg: any): arg is models.CTCustomizationDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // code?: string
    ( typeof arg.code === 'undefined' || typeof arg.code === 'string' ) &&
    // createdBy?: string
    ( typeof arg.createdBy === 'undefined' || typeof arg.createdBy === 'string' ) &&
    // creationDate?: string
    ( typeof arg.creationDate === 'undefined' || typeof arg.creationDate === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&

  true
  );
  }

export function isCTErrorCodeDto(arg: any): arg is models.CTErrorCodeDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // description?: string
    ( typeof arg.description === 'undefined' || typeof arg.description === 'string' ) &&
    // errNum?: number
    ( typeof arg.errNum === 'undefined' || typeof arg.errNum === 'number' ) &&
    // errTxt?: string
    ( typeof arg.errTxt === 'undefined' || typeof arg.errTxt === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // productType?: CTProductTypeDto
    ( typeof arg.productType === 'undefined' || isCTProductTypeDto(arg.productType) ) &&
    // validFrom?: string
    ( typeof arg.validFrom === 'undefined' || typeof arg.validFrom === 'string' ) &&
    // validTo?: string
    ( typeof arg.validTo === 'undefined' || typeof arg.validTo === 'string' ) &&

  true
  );
  }

export function isCTHIPAgeLimitTypeDto(arg: any): arg is models.CTHIPAgeLimitTypeDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // iD: number
    ( typeof arg.iD === 'number' ) &&
    // maximumAgeLimit?: number
    ( typeof arg.maximumAgeLimit === 'undefined' || typeof arg.maximumAgeLimit === 'number' ) &&
    // minimumAgeLimit?: number
    ( typeof arg.minimumAgeLimit === 'undefined' || typeof arg.minimumAgeLimit === 'number' ) &&
    // minimumAgeLimitTpyeEnglish?: string
    ( typeof arg.minimumAgeLimitTpyeEnglish === 'undefined' || typeof arg.minimumAgeLimitTpyeEnglish === 'string' ) &&
    // minimumAgeLimitType?: string
    ( typeof arg.minimumAgeLimitType === 'undefined' || typeof arg.minimumAgeLimitType === 'string' ) &&

  true
  );
  }

export function isCTHIPCustomerTypeDto(arg: any): arg is models.CTHIPCustomerTypeDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // customerType?: string
    ( typeof arg.customerType === 'undefined' || typeof arg.customerType === 'string' ) &&
    // customerTypeEnglish?: string
    ( typeof arg.customerTypeEnglish === 'undefined' || typeof arg.customerTypeEnglish === 'string' ) &&
    // customerTypeGenitive?: string
    ( typeof arg.customerTypeGenitive === 'undefined' || typeof arg.customerTypeGenitive === 'string' ) &&
    // customerTypeGenitiveEnglish?: string
    ( typeof arg.customerTypeGenitiveEnglish === 'undefined' || typeof arg.customerTypeGenitiveEnglish === 'string' ) &&
    // customerTypePartial?: string
    ( typeof arg.customerTypePartial === 'undefined' || typeof arg.customerTypePartial === 'string' ) &&
    // customerTypePartialEnglish?: string
    ( typeof arg.customerTypePartialEnglish === 'undefined' || typeof arg.customerTypePartialEnglish === 'string' ) &&
    // iD: number
    ( typeof arg.iD === 'number' ) &&

  true
  );
  }

export function isCTHistoryTypeDto(arg: any): arg is models.CTHistoryTypeDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // description?: string
    ( typeof arg.description === 'undefined' || typeof arg.description === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // sID?: string
    ( typeof arg.sID === 'undefined' || typeof arg.sID === 'string' ) &&
    // validFrom?: string
    ( typeof arg.validFrom === 'undefined' || typeof arg.validFrom === 'string' ) &&
    // validTo?: string
    ( typeof arg.validTo === 'undefined' || typeof arg.validTo === 'string' ) &&

  true
  );
  }

export function isCTLogTypeDto(arg: any): arg is models.CTLogTypeDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&

  true
  );
  }

export function isCTPaymentFreqDto(arg: any): arg is models.CTPaymentFreqDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // description?: string
    ( typeof arg.description === 'undefined' || typeof arg.description === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // koopID?: string
    ( typeof arg.koopID === 'undefined' || typeof arg.koopID === 'string' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // netOfferPaymentFreqID?: number
    ( typeof arg.netOfferPaymentFreqID === 'undefined' || typeof arg.netOfferPaymentFreqID === 'number' ) &&
    // sID?: string
    ( typeof arg.sID === 'undefined' || typeof arg.sID === 'string' ) &&
    // validFrom?: string
    ( typeof arg.validFrom === 'undefined' || typeof arg.validFrom === 'string' ) &&
    // validTo?: string
    ( typeof arg.validTo === 'undefined' || typeof arg.validTo === 'string' ) &&

  true
  );
  }

export function isCTPaymentTypeDto(arg: any): arg is models.CTPaymentTypeDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // description?: string
    ( typeof arg.description === 'undefined' || typeof arg.description === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // koopID?: string
    ( typeof arg.koopID === 'undefined' || typeof arg.koopID === 'string' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // netOfferPaymentTypeID?: number
    ( typeof arg.netOfferPaymentTypeID === 'undefined' || typeof arg.netOfferPaymentTypeID === 'number' ) &&
    // sID?: string
    ( typeof arg.sID === 'undefined' || typeof arg.sID === 'string' ) &&
    // validFrom?: string
    ( typeof arg.validFrom === 'undefined' || typeof arg.validFrom === 'string' ) &&
    // validTo?: string
    ( typeof arg.validTo === 'undefined' || typeof arg.validTo === 'string' ) &&

  true
  );
  }

export function isCTProcessTypeDto(arg: any): arg is models.CTProcessTypeDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // description?: string
    ( typeof arg.description === 'undefined' || typeof arg.description === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // sID?: string
    ( typeof arg.sID === 'undefined' || typeof arg.sID === 'string' ) &&
    // validFrom?: string
    ( typeof arg.validFrom === 'undefined' || typeof arg.validFrom === 'string' ) &&
    // validTo?: string
    ( typeof arg.validTo === 'undefined' || typeof arg.validTo === 'string' ) &&

  true
  );
  }

export function isCTProductTypeDto(arg: any): arg is models.CTProductTypeDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // description?: string
    ( typeof arg.description === 'undefined' || typeof arg.description === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // isActive?: boolean
    ( typeof arg.isActive === 'undefined' || typeof arg.isActive === 'boolean' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // sID?: string
    ( typeof arg.sID === 'undefined' || typeof arg.sID === 'string' ) &&
    // validFrom?: string
    ( typeof arg.validFrom === 'undefined' || typeof arg.validFrom === 'string' ) &&
    // validTo?: string
    ( typeof arg.validTo === 'undefined' || typeof arg.validTo === 'string' ) &&

  true
  );
  }

export function isCTRiskDto(arg: any): arg is models.CTRiskDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // description?: string
    ( typeof arg.description === 'undefined' || typeof arg.description === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // koopRiskID?: string
    ( typeof arg.koopRiskID === 'undefined' || typeof arg.koopRiskID === 'string' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // productType?: CTProductTypeDto
    ( typeof arg.productType === 'undefined' || isCTProductTypeDto(arg.productType) ) &&
    // riskType?: CTRiskTypeDto
    ( typeof arg.riskType === 'undefined' || isCTRiskTypeDto(arg.riskType) ) &&
    // sID?: string
    ( typeof arg.sID === 'undefined' || typeof arg.sID === 'string' ) &&
    // validFrom?: string
    ( typeof arg.validFrom === 'undefined' || typeof arg.validFrom === 'string' ) &&
    // validTo?: string
    ( typeof arg.validTo === 'undefined' || typeof arg.validTo === 'string' ) &&

  true
  );
  }

export function isCTRiskTypeDto(arg: any): arg is models.CTRiskTypeDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // description?: string
    ( typeof arg.description === 'undefined' || typeof arg.description === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // productType?: CTProductTypeDto
    ( typeof arg.productType === 'undefined' || isCTProductTypeDto(arg.productType) ) &&
    // sID?: string
    ( typeof arg.sID === 'undefined' || typeof arg.sID === 'string' ) &&
    // validFrom?: string
    ( typeof arg.validFrom === 'undefined' || typeof arg.validFrom === 'string' ) &&
    // validTo?: string
    ( typeof arg.validTo === 'undefined' || typeof arg.validTo === 'string' ) &&

  true
  );
  }

export function isCTRoleDto(arg: any): arg is models.CTRoleDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // sID?: string
    ( typeof arg.sID === 'undefined' || typeof arg.sID === 'string' ) &&
    // validFrom?: string
    ( typeof arg.validFrom === 'undefined' || typeof arg.validFrom === 'string' ) &&
    // validTo?: string
    ( typeof arg.validTo === 'undefined' || typeof arg.validTo === 'string' ) &&

  true
  );
  }

export function isCTSexDto(arg: any): arg is models.CTSexDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // description?: string
    ( typeof arg.description === 'undefined' || typeof arg.description === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // koopID?: string
    ( typeof arg.koopID === 'undefined' || typeof arg.koopID === 'string' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // netOfferSexID?: number
    ( typeof arg.netOfferSexID === 'undefined' || typeof arg.netOfferSexID === 'number' ) &&
    // sID?: string
    ( typeof arg.sID === 'undefined' || typeof arg.sID === 'string' ) &&
    // validFrom?: string
    ( typeof arg.validFrom === 'undefined' || typeof arg.validFrom === 'string' ) &&
    // validTo?: string
    ( typeof arg.validTo === 'undefined' || typeof arg.validTo === 'string' ) &&

  true
  );
  }

export function isCTStateDto(arg: any): arg is models.CTStateDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // description?: string
    ( typeof arg.description === 'undefined' || typeof arg.description === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // isActive?: boolean
    ( typeof arg.isActive === 'undefined' || typeof arg.isActive === 'boolean' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // sID?: string
    ( typeof arg.sID === 'undefined' || typeof arg.sID === 'string' ) &&
    // validFrom?: string
    ( typeof arg.validFrom === 'undefined' || typeof arg.validFrom === 'string' ) &&
    // validTo?: string
    ( typeof arg.validTo === 'undefined' || typeof arg.validTo === 'string' ) &&

  true
  );
  }

export function isCTTaskDto(arg: any): arg is models.CTTaskDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // description?: string
    ( typeof arg.description === 'undefined' || typeof arg.description === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&

  true
  );
  }

export function isCTVariantIDDto(arg: any): arg is models.CTVariantIDDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // isIndividual?: boolean
    ( typeof arg.isIndividual === 'undefined' || typeof arg.isIndividual === 'boolean' ) &&
    // koopRiskID?: number
    ( typeof arg.koopRiskID === 'undefined' || typeof arg.koopRiskID === 'number' ) &&
    // length?: number
    ( typeof arg.length === 'undefined' || typeof arg.length === 'number' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // netOfferColumnNameAndValue?: string
    ( typeof arg.netOfferColumnNameAndValue === 'undefined' || typeof arg.netOfferColumnNameAndValue === 'string' ) &&
    // positionStart?: number
    ( typeof arg.positionStart === 'undefined' || typeof arg.positionStart === 'number' ) &&
    // productTypeID?: CTProductTypeDto
    ( typeof arg.productTypeID === 'undefined' || isCTProductTypeDto(arg.productTypeID) ) &&
    // value?: string
    ( typeof arg.value === 'undefined' || typeof arg.value === 'string' ) &&

  true
  );
  }

export function isCustomizationDto(arg: any): arg is models.CustomizationDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // contractID?: number
    ( typeof arg.contractID === 'undefined' || typeof arg.contractID === 'number' ) &&
    // createdBy?: string
    ( typeof arg.createdBy === 'undefined' || typeof arg.createdBy === 'string' ) &&
    // creationDate?: string
    ( typeof arg.creationDate === 'undefined' || typeof arg.creationDate === 'string' ) &&
    // customizationID?: CTCustomizationDto
    ( typeof arg.customizationID === 'undefined' || isCTCustomizationDto(arg.customizationID) ) &&
    // customizationOption?: string
    ( typeof arg.customizationOption === 'undefined' || typeof arg.customizationOption === 'string' ) &&
    // deletedBy?: string
    ( typeof arg.deletedBy === 'undefined' || typeof arg.deletedBy === 'string' ) &&
    // deletionDate?: string
    ( typeof arg.deletionDate === 'undefined' || typeof arg.deletionDate === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // koopFrameContractId?: string
    ( typeof arg.koopFrameContractId === 'undefined' || typeof arg.koopFrameContractId === 'string' ) &&
    // koopSubContractId?: string
    ( typeof arg.koopSubContractId === 'undefined' || typeof arg.koopSubContractId === 'string' ) &&
    // packageId?: number
    ( typeof arg.packageId === 'undefined' || typeof arg.packageId === 'number' ) &&
    // risk?: CTRiskDto
    ( typeof arg.risk === 'undefined' || isCTRiskDto(arg.risk) ) &&
    // riskId?: number
    ( typeof arg.riskId === 'undefined' || typeof arg.riskId === 'number' ) &&
    // status?: string
    ( typeof arg.status === 'undefined' || typeof arg.status === 'string' ) &&
    // subContractID?: number
    ( typeof arg.subContractID === 'undefined' || typeof arg.subContractID === 'number' ) &&

  true
  );
  }

export function isErrorDto(arg: any): arg is models.ErrorDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // code?: number
    ( typeof arg.code === 'undefined' || typeof arg.code === 'number' ) &&
    // detailedMessage?: string
    ( typeof arg.detailedMessage === 'undefined' || typeof arg.detailedMessage === 'string' ) &&
    // message?: string
    ( typeof arg.message === 'undefined' || typeof arg.message === 'string' ) &&
    // stackTrace?: string
    ( typeof arg.stackTrace === 'undefined' || typeof arg.stackTrace === 'string' ) &&

  true
  );
  }

export function isFileDto(arg: any): arg is models.FileDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // cirUserId: number
    ( typeof arg.cirUserId === 'number' ) &&
    // creationDate: string
    ( typeof arg.creationDate === 'string' ) &&
    // fileExtension?: string
    ( typeof arg.fileExtension === 'undefined' || typeof arg.fileExtension === 'string' ) &&
    // fileName?: string
    ( typeof arg.fileName === 'undefined' || typeof arg.fileName === 'string' ) &&
    // fileSize: number
    ( typeof arg.fileSize === 'number' ) &&
    // id: number
    ( typeof arg.id === 'number' ) &&
    // ip?: string
    ( typeof arg.ip === 'undefined' || typeof arg.ip === 'string' ) &&

  true
  );
  }

export function isFilterDto(arg: any): arg is models.FilterDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // field?: string
    ( typeof arg.field === 'undefined' || typeof arg.field === 'string' ) &&
    // matchingPattern?: 'EQUALS' | 'LESS' | 'LESSOREQUALS' | 'GREATER' | 'GREATEROREQUALS' | 'CONTAINS' | 'STARTSWITH' | 'ENDSWITH'
    ( typeof arg.matchingPattern === 'undefined' || ['EQUALS', 'LESS', 'LESSOREQUALS', 'GREATER', 'GREATEROREQUALS', 'CONTAINS', 'STARTSWITH', 'ENDSWITH'].includes(arg.matchingPattern) ) &&
    // typeOfValue?: string
    ( typeof arg.typeOfValue === 'undefined' || typeof arg.typeOfValue === 'string' ) &&
    // value?: object
    ( typeof arg.value === 'undefined' || typeof arg.value === 'object' ) &&

  true
  );
  }

export function isFilteredSortedPagedDto(arg: any): arg is models.FilteredSortedPagedDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // filtering?: FilterDto[]
    ( typeof arg.filtering === 'undefined' || (Array.isArray(arg.filtering) && arg.filtering.every((item: unknown) => isFilterDto(item))) ) &&
    // paging?: PaginationDto
    ( typeof arg.paging === 'undefined' || isPaginationDto(arg.paging) ) &&
    // sorting?: SortDto[]
    ( typeof arg.sorting === 'undefined' || (Array.isArray(arg.sorting) && arg.sorting.every((item: unknown) => isSortDto(item))) ) &&

  true
  );
  }

export function isFormattedMessagePlaceholderValuesDto(arg: any): arg is models.FormattedMessagePlaceholderValuesDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // ComparisonProperty?: string
    ( typeof arg.ComparisonProperty === 'undefined' || typeof arg.ComparisonProperty === 'string' ) &&
    // ComparisonValue?: object
    ( typeof arg.ComparisonValue === 'undefined' || typeof arg.ComparisonValue === 'object' ) &&
    // formattedMessagePlaceholderValues?: FormattedMessagePlaceholderValuesDto
    ( typeof arg.formattedMessagePlaceholderValues === 'undefined' || isFormattedMessagePlaceholderValuesDto(arg.formattedMessagePlaceholderValues) ) &&
    // PropertyName?: string
    ( typeof arg.PropertyName === 'undefined' || typeof arg.PropertyName === 'string' ) &&
    // PropertyValue?: object
    ( typeof arg.PropertyValue === 'undefined' || typeof arg.PropertyValue === 'object' ) &&

  true
  );
  }

export function isGetCaptchaStyledResultDto(arg: any): arg is models.GetCaptchaStyledResultDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // accessToken?: string
    ( typeof arg.accessToken === 'undefined' || typeof arg.accessToken === 'string' ) &&
    // picture?: string
    ( typeof arg.picture === 'undefined' || typeof arg.picture === 'string' ) &&

  true
  );
  }

export function isGetXMLForAMLOGDto(arg: any): arg is models.GetXMLForAMLOGDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // createDate?: string
    ( typeof arg.createDate === 'undefined' || typeof arg.createDate === 'string' ) &&
    // errorMsg?: string
    ( typeof arg.errorMsg === 'undefined' || typeof arg.errorMsg === 'string' ) &&
    // expType?: string
    ( typeof arg.expType === 'undefined' || typeof arg.expType === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // isSuccess?: boolean
    ( typeof arg.isSuccess === 'undefined' || typeof arg.isSuccess === 'boolean' ) &&
    // parameters?: string
    ( typeof arg.parameters === 'undefined' || typeof arg.parameters === 'string' ) &&

  true
  );
  }

export function isGroupDto(arg: any): arg is models.GroupDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // additionalName?: string
    ( typeof arg.additionalName === 'undefined' || typeof arg.additionalName === 'string' ) &&
    // createdBy?: string
    ( typeof arg.createdBy === 'undefined' || typeof arg.createdBy === 'string' ) &&
    // creationDate?: string
    ( typeof arg.creationDate === 'undefined' || typeof arg.creationDate === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // isActive?: boolean
    ( typeof arg.isActive === 'undefined' || typeof arg.isActive === 'boolean' ) &&
    // koopFrameContractID?: string
    ( typeof arg.koopFrameContractID === 'undefined' || typeof arg.koopFrameContractID === 'string' ) &&
    // koopGroupID?: string
    ( typeof arg.koopGroupID === 'undefined' || typeof arg.koopGroupID === 'string' ) &&
    // koopGroupName?: string
    ( typeof arg.koopGroupName === 'undefined' || typeof arg.koopGroupName === 'string' ) &&
    // koopSubContractID?: string
    ( typeof arg.koopSubContractID === 'undefined' || typeof arg.koopSubContractID === 'string' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // risks?: RiskDto[]
    ( typeof arg.risks === 'undefined' || (Array.isArray(arg.risks) && arg.risks.every((item: unknown) => isRiskDto(item))) ) &&

  true
  );
  }

export function isHIPContractDto(arg: any): arg is models.HIPContractDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // ageOfAdultPackage?: number
    ( typeof arg.ageOfAdultPackage === 'undefined' || typeof arg.ageOfAdultPackage === 'number' ) &&
    // contractGroups?: HIPSubContractDto[]
    ( typeof arg.contractGroups === 'undefined' || (Array.isArray(arg.contractGroups) && arg.contractGroups.every((item: unknown) => isHIPSubContractDto(item))) ) &&
    // contractorName?: string
    ( typeof arg.contractorName === 'undefined' || typeof arg.contractorName === 'string' ) &&
    // frameStartDate?: string
    ( typeof arg.frameStartDate === 'undefined' || typeof arg.frameStartDate === 'string' ) &&
    // hasEnglishVersion?: boolean
    ( typeof arg.hasEnglishVersion === 'undefined' || typeof arg.hasEnglishVersion === 'boolean' ) &&
    // hipAgeLimitType?: CTHIPAgeLimitTypeDto
    ( typeof arg.hipAgeLimitType === 'undefined' || isCTHIPAgeLimitTypeDto(arg.hipAgeLimitType) ) &&
    // hipCustomerType?: CTHIPCustomerTypeDto
    ( typeof arg.hipCustomerType === 'undefined' || isCTHIPCustomerTypeDto(arg.hipCustomerType) ) &&
    // koopFrameContractId?: string
    ( typeof arg.koopFrameContractId === 'undefined' || typeof arg.koopFrameContractId === 'string' ) &&
    // paymentFrequencyOptions?: PaymentFrequencyDto
    ( typeof arg.paymentFrequencyOptions === 'undefined' || isPaymentFrequencyDto(arg.paymentFrequencyOptions) ) &&
    // subContractNextStartDate?: string
    ( typeof arg.subContractNextStartDate === 'undefined' || typeof arg.subContractNextStartDate === 'string' ) &&

  true
  );
  }

export function isHIPCouponDto(arg: any): arg is models.HIPCouponDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // couponCode?: string
    ( typeof arg.couponCode === 'undefined' || typeof arg.couponCode === 'string' ) &&
    // couponName: string
    ( typeof arg.couponName === 'string' ) &&
    // createdAt?: string
    ( typeof arg.createdAt === 'undefined' || typeof arg.createdAt === 'string' ) &&
    // createdBy?: string
    ( typeof arg.createdBy === 'undefined' || typeof arg.createdBy === 'string' ) &&
    // id?: number
    ( typeof arg.id === 'undefined' || typeof arg.id === 'number' ) &&
    // koopFrameContractId: string
    ( typeof arg.koopFrameContractId === 'string' ) &&
    // modifiedAt?: string
    ( typeof arg.modifiedAt === 'undefined' || typeof arg.modifiedAt === 'string' ) &&
    // modifiedBy?: string
    ( typeof arg.modifiedBy === 'undefined' || typeof arg.modifiedBy === 'string' ) &&
    // validFrom: string
    ( typeof arg.validFrom === 'string' ) &&
    // validTo?: string
    ( typeof arg.validTo === 'undefined' || typeof arg.validTo === 'string' ) &&

  true
  );
  }

export function isHIPEmployeeDto(arg: any): arg is models.HIPEmployeeDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // birthDate?: string
    ( typeof arg.birthDate === 'undefined' || typeof arg.birthDate === 'string' ) &&
    // id?: number
    ( typeof arg.id === 'undefined' || typeof arg.id === 'number' ) &&
    // koopFrameContractId?: string
    ( typeof arg.koopFrameContractId === 'undefined' || typeof arg.koopFrameContractId === 'string' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&

  true
  );
  }

export function isHIPFileDto(arg: any): arg is models.HIPFileDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // fileContentInByte?: string
    ( typeof arg.fileContentInByte === 'undefined' || typeof arg.fileContentInByte === 'string' ) &&
    // fileName?: string
    ( typeof arg.fileName === 'undefined' || typeof arg.fileName === 'string' ) &&

  true
  );
  }

export function isHIPInsuranceFeeDto(arg: any): arg is models.HIPInsuranceFeeDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // annualFee?: number
    ( typeof arg.annualFee === 'undefined' || typeof arg.annualFee === 'number' ) &&
    // monthlyFee?: number
    ( typeof arg.monthlyFee === 'undefined' || typeof arg.monthlyFee === 'number' ) &&
    // quarterlyFee?: number
    ( typeof arg.quarterlyFee === 'undefined' || typeof arg.quarterlyFee === 'number' ) &&
    // semiAnnualFee?: number
    ( typeof arg.semiAnnualFee === 'undefined' || typeof arg.semiAnnualFee === 'number' ) &&

  true
  );
  }

export function isHIPInsuredPersonDto(arg: any): arg is models.HIPInsuredPersonDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // addressCity?: string
    ( typeof arg.addressCity === 'undefined' || typeof arg.addressCity === 'string' ) &&
    // addressHouseNr?: string
    ( typeof arg.addressHouseNr === 'undefined' || typeof arg.addressHouseNr === 'string' ) &&
    // addressState?: string
    ( typeof arg.addressState === 'undefined' || typeof arg.addressState === 'string' ) &&
    // addressStreet?: string
    ( typeof arg.addressStreet === 'undefined' || typeof arg.addressStreet === 'string' ) &&
    // addressZip?: string
    ( typeof arg.addressZip === 'undefined' || typeof arg.addressZip === 'string' ) &&
    // birthDate?: string
    ( typeof arg.birthDate === 'undefined' || typeof arg.birthDate === 'string' ) &&
    // birthName?: string
    ( typeof arg.birthName === 'undefined' || typeof arg.birthName === 'string' ) &&
    // birthPlace?: string
    ( typeof arg.birthPlace === 'undefined' || typeof arg.birthPlace === 'string' ) &&
    // drivingLicence?: string
    ( typeof arg.drivingLicence === 'undefined' || typeof arg.drivingLicence === 'string' ) &&
    // email?: string
    ( typeof arg.email === 'undefined' || typeof arg.email === 'string' ) &&
    // firstName?: string
    ( typeof arg.firstName === 'undefined' || typeof arg.firstName === 'string' ) &&
    // identityCard?: string
    ( typeof arg.identityCard === 'undefined' || typeof arg.identityCard === 'string' ) &&
    // lastName?: string
    ( typeof arg.lastName === 'undefined' || typeof arg.lastName === 'string' ) &&
    // mobileNumber?: string
    ( typeof arg.mobileNumber === 'undefined' || typeof arg.mobileNumber === 'string' ) &&
    // mothersName?: string
    ( typeof arg.mothersName === 'undefined' || typeof arg.mothersName === 'string' ) &&
    // passport?: string
    ( typeof arg.passport === 'undefined' || typeof arg.passport === 'string' ) &&
    // postalAddressCity?: string
    ( typeof arg.postalAddressCity === 'undefined' || typeof arg.postalAddressCity === 'string' ) &&
    // postalAddressHouseNr?: string
    ( typeof arg.postalAddressHouseNr === 'undefined' || typeof arg.postalAddressHouseNr === 'string' ) &&
    // postalAddressState?: string
    ( typeof arg.postalAddressState === 'undefined' || typeof arg.postalAddressState === 'string' ) &&
    // postalAddressStreet?: string
    ( typeof arg.postalAddressStreet === 'undefined' || typeof arg.postalAddressStreet === 'string' ) &&
    // postalAddressZip?: string
    ( typeof arg.postalAddressZip === 'undefined' || typeof arg.postalAddressZip === 'string' ) &&
    // residencePermitNumber?: string
    ( typeof arg.residencePermitNumber === 'undefined' || typeof arg.residencePermitNumber === 'string' ) &&
    // socialSecurityNumber?: string
    ( typeof arg.socialSecurityNumber === 'undefined' || typeof arg.socialSecurityNumber === 'string' ) &&
    // taxNumber?: string
    ( typeof arg.taxNumber === 'undefined' || typeof arg.taxNumber === 'string' ) &&
    // title?: string
    ( typeof arg.title === 'undefined' || typeof arg.title === 'string' ) &&

  true
  );
  }

export function isHIPInsuredPersonFromHIPDto(arg: any): arg is models.HIPInsuredPersonFromHIPDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // contractGroupFirstLevelRisksName?: string
    ( typeof arg.contractGroupFirstLevelRisksName === 'undefined' || typeof arg.contractGroupFirstLevelRisksName === 'string' ) &&
    // contractGroupId?: string
    ( typeof arg.contractGroupId === 'undefined' || typeof arg.contractGroupId === 'string' ) &&
    // contractGroupName?: string
    ( typeof arg.contractGroupName === 'undefined' || typeof arg.contractGroupName === 'string' ) &&
    // contractGroupSubName?: string
    ( typeof arg.contractGroupSubName === 'undefined' || typeof arg.contractGroupSubName === 'string' ) &&
    // contractorName?: string
    ( typeof arg.contractorName === 'undefined' || typeof arg.contractorName === 'string' ) &&
    // couponCode?: string
    ( typeof arg.couponCode === 'undefined' || typeof arg.couponCode === 'string' ) &&
    // creationDate?: string
    ( typeof arg.creationDate === 'undefined' || typeof arg.creationDate === 'string' ) &&
    // emailSendingStatus?: string
    ( typeof arg.emailSendingStatus === 'undefined' || typeof arg.emailSendingStatus === 'string' ) &&
    // emailSentDateTime?: string
    ( typeof arg.emailSentDateTime === 'undefined' || typeof arg.emailSentDateTime === 'string' ) &&
    // employee?: HIPEmployeeDto
    ( typeof arg.employee === 'undefined' || isHIPEmployeeDto(arg.employee) ) &&
    // frequencyFee?: number
    ( typeof arg.frequencyFee === 'undefined' || typeof arg.frequencyFee === 'number' ) &&
    // id?: number
    ( typeof arg.id === 'undefined' || typeof arg.id === 'number' ) &&
    // insuranceFee?: HIPInsuranceFeeDto
    ( typeof arg.insuranceFee === 'undefined' || isHIPInsuranceFeeDto(arg.insuranceFee) ) &&
    // insuredPerson?: HIPInsuredPersonDto
    ( typeof arg.insuredPerson === 'undefined' || isHIPInsuredPersonDto(arg.insuredPerson) ) &&
    // interruptionDate?: string
    ( typeof arg.interruptionDate === 'undefined' || typeof arg.interruptionDate === 'string' ) &&
    // interruptionId?: string
    ( typeof arg.interruptionId === 'undefined' || typeof arg.interruptionId === 'string' ) &&
    // isAdult?: boolean
    ( typeof arg.isAdult === 'undefined' || typeof arg.isAdult === 'boolean' ) &&
    // koopFrameContractId?: string
    ( typeof arg.koopFrameContractId === 'undefined' || typeof arg.koopFrameContractId === 'string' ) &&
    // legalGuardian?: string
    ( typeof arg.legalGuardian === 'undefined' || typeof arg.legalGuardian === 'string' ) &&
    // linkType?: string
    ( typeof arg.linkType === 'undefined' || typeof arg.linkType === 'string' ) &&
    // offerNumber?: string
    ( typeof arg.offerNumber === 'undefined' || typeof arg.offerNumber === 'string' ) &&
    // paymentCode?: string
    ( typeof arg.paymentCode === 'undefined' || typeof arg.paymentCode === 'string' ) &&
    // paymentDate?: string
    ( typeof arg.paymentDate === 'undefined' || typeof arg.paymentDate === 'string' ) &&
    // paymentFrequency?: string
    ( typeof arg.paymentFrequency === 'undefined' || typeof arg.paymentFrequency === 'string' ) &&
    // paymentTransactionCode?: string
    ( typeof arg.paymentTransactionCode === 'undefined' || typeof arg.paymentTransactionCode === 'string' ) &&
    // paymentType?: string
    ( typeof arg.paymentType === 'undefined' || typeof arg.paymentType === 'string' ) &&
    // riskStartDate?: string
    ( typeof arg.riskStartDate === 'undefined' || typeof arg.riskStartDate === 'string' ) &&
    // state?: string
    ( typeof arg.state === 'undefined' || typeof arg.state === 'string' ) &&

  true
  );
  }

export function isHIPMainRiskDto(arg: any): arg is models.HIPMainRiskDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // contractGroupId?: number
    ( typeof arg.contractGroupId === 'undefined' || typeof arg.contractGroupId === 'number' ) &&
    // koopFrameContractId?: string
    ( typeof arg.koopFrameContractId === 'undefined' || typeof arg.koopFrameContractId === 'string' ) &&
    // riskDescription?: string
    ( typeof arg.riskDescription === 'undefined' || typeof arg.riskDescription === 'string' ) &&
    // riskDisplayIconName?: string
    ( typeof arg.riskDisplayIconName === 'undefined' || typeof arg.riskDisplayIconName === 'string' ) &&
    // riskDisplayName?: string
    ( typeof arg.riskDisplayName === 'undefined' || typeof arg.riskDisplayName === 'string' ) &&
    // riskExtraInfo?: string
    ( typeof arg.riskExtraInfo === 'undefined' || typeof arg.riskExtraInfo === 'string' ) &&
    // riskId?: string
    ( typeof arg.riskId === 'undefined' || typeof arg.riskId === 'string' ) &&
    // riskLimit?: string
    ( typeof arg.riskLimit === 'undefined' || typeof arg.riskLimit === 'string' ) &&
    // riskOrder?: number
    ( typeof arg.riskOrder === 'undefined' || typeof arg.riskOrder === 'number' ) &&
    // riskType?: number
    ( typeof arg.riskType === 'undefined' || typeof arg.riskType === 'number' ) &&
    // second_level_risk?: HIPSubRiskDto[]
    ( typeof arg.second_level_risk === 'undefined' || (Array.isArray(arg.second_level_risk) && arg.second_level_risk.every((item: unknown) => isHIPSubRiskDto(item))) ) &&

  true
  );
  }

export function isHIPSubContractDto(arg: any): arg is models.HIPSubContractDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // contractGroupFirstLevelRisksName?: string
    ( typeof arg.contractGroupFirstLevelRisksName === 'undefined' || typeof arg.contractGroupFirstLevelRisksName === 'string' ) &&
    // contractGroupId?: number
    ( typeof arg.contractGroupId === 'undefined' || typeof arg.contractGroupId === 'number' ) &&
    // displayName?: string
    ( typeof arg.displayName === 'undefined' || typeof arg.displayName === 'string' ) &&
    // displaySubName?: string
    ( typeof arg.displaySubName === 'undefined' || typeof arg.displaySubName === 'string' ) &&
    // first_level_risks?: HIPMainRiskDto[]
    ( typeof arg.first_level_risks === 'undefined' || (Array.isArray(arg.first_level_risks) && arg.first_level_risks.every((item: unknown) => isHIPMainRiskDto(item))) ) &&
    // forChildren?: boolean
    ( typeof arg.forChildren === 'undefined' || typeof arg.forChildren === 'boolean' ) &&
    // frequencyFee?: number
    ( typeof arg.frequencyFee === 'undefined' || typeof arg.frequencyFee === 'number' ) &&
    // insuranceFee?: HIPInsuranceFeeDto
    ( typeof arg.insuranceFee === 'undefined' || isHIPInsuranceFeeDto(arg.insuranceFee) ) &&
    // koopFrameContractId?: string
    ( typeof arg.koopFrameContractId === 'undefined' || typeof arg.koopFrameContractId === 'string' ) &&

  true
  );
  }

export function isHIPSubRiskDto(arg: any): arg is models.HIPSubRiskDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // contractGroupId?: number
    ( typeof arg.contractGroupId === 'undefined' || typeof arg.contractGroupId === 'number' ) &&
    // koopFrameContractId?: string
    ( typeof arg.koopFrameContractId === 'undefined' || typeof arg.koopFrameContractId === 'string' ) &&
    // riskDescription?: string
    ( typeof arg.riskDescription === 'undefined' || typeof arg.riskDescription === 'string' ) &&
    // riskDisplayIconName?: string
    ( typeof arg.riskDisplayIconName === 'undefined' || typeof arg.riskDisplayIconName === 'string' ) &&
    // riskDisplayName?: string
    ( typeof arg.riskDisplayName === 'undefined' || typeof arg.riskDisplayName === 'string' ) &&
    // riskId?: string
    ( typeof arg.riskId === 'undefined' || typeof arg.riskId === 'string' ) &&
    // riskLimit?: string
    ( typeof arg.riskLimit === 'undefined' || typeof arg.riskLimit === 'string' ) &&
    // riskOrder?: number
    ( typeof arg.riskOrder === 'undefined' || typeof arg.riskOrder === 'number' ) &&
    // riskType?: number
    ( typeof arg.riskType === 'undefined' || typeof arg.riskType === 'number' ) &&

  true
  );
  }

export function isHrAdminContractDto(arg: any): arg is models.HrAdminContractDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // cirUserId?: number
    ( typeof arg.cirUserId === 'undefined' || typeof arg.cirUserId === 'number' ) &&
    // cirUserIsAdmin?: boolean
    ( typeof arg.cirUserIsAdmin === 'undefined' || typeof arg.cirUserIsAdmin === 'boolean' ) &&
    // contractId?: number
    ( typeof arg.contractId === 'undefined' || typeof arg.contractId === 'number' ) &&
    // email?: string
    ( typeof arg.email === 'undefined' || typeof arg.email === 'string' ) &&
    // firstName?: string
    ( typeof arg.firstName === 'undefined' || typeof arg.firstName === 'string' ) &&
    // isMainContactPerson?: boolean
    ( typeof arg.isMainContactPerson === 'undefined' || typeof arg.isMainContactPerson === 'boolean' ) &&
    // lastName?: string
    ( typeof arg.lastName === 'undefined' || typeof arg.lastName === 'string' ) &&

  true
  );
  }

export function isIndexationDataDto(arg: any): arg is models.IndexationDataDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // indexationPercentage?: number
    ( typeof arg.indexationPercentage === 'undefined' || typeof arg.indexationPercentage === 'number' ) &&
    // indexationPercentagePrev?: number
    ( typeof arg.indexationPercentagePrev === 'undefined' || typeof arg.indexationPercentagePrev === 'number' ) &&
    // lastIndexationDate?: string
    ( typeof arg.lastIndexationDate === 'undefined' || typeof arg.lastIndexationDate === 'string' ) &&

  true
  );
  }

export function isInsurancePeriodDto(arg: any): arg is models.InsurancePeriodDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // createdBy?: string
    ( typeof arg.createdBy === 'undefined' || typeof arg.createdBy === 'string' ) &&
    // creationDate?: string
    ( typeof arg.creationDate === 'undefined' || typeof arg.creationDate === 'string' ) &&
    // HealthServiceAdminChangeToAM?: string
    ( typeof arg.HealthServiceAdminChangeToAM === 'undefined' || typeof arg.HealthServiceAdminChangeToAM === 'string' ) &&
    // HealthServiceAdminChangeToUE?: string
    ( typeof arg.HealthServiceAdminChangeToUE === 'undefined' || typeof arg.HealthServiceAdminChangeToUE === 'string' ) &&
    // InsuredPersonRelationHistoryID?: number
    ( typeof arg.InsuredPersonRelationHistoryID === 'undefined' || typeof arg.InsuredPersonRelationHistoryID === 'number' ) &&
    // InsuredPersonRelationID?: number
    ( typeof arg.InsuredPersonRelationID === 'undefined' || typeof arg.InsuredPersonRelationID === 'number' ) &&
    // PartnerTypeID?: number
    ( typeof arg.PartnerTypeID === 'undefined' || typeof arg.PartnerTypeID === 'number' ) &&
    // PersonID?: number
    ( typeof arg.PersonID === 'undefined' || typeof arg.PersonID === 'number' ) &&
    // PersonRelationID?: number
    ( typeof arg.PersonRelationID === 'undefined' || typeof arg.PersonRelationID === 'number' ) &&
    // RiskEndDate?: string
    ( typeof arg.RiskEndDate === 'undefined' || typeof arg.RiskEndDate === 'string' ) &&
    // RiskStartDate?: string
    ( typeof arg.RiskStartDate === 'undefined' || typeof arg.RiskStartDate === 'string' ) &&
    // SubContractID?: number
    ( typeof arg.SubContractID === 'undefined' || typeof arg.SubContractID === 'number' ) &&

  true
  );
  }

export function isInsurantsSearchListItemDto(arg: any): arg is models.InsurantsSearchListItemDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // administrationGroupId?: number
    ( typeof arg.administrationGroupId === 'undefined' || typeof arg.administrationGroupId === 'number' ) &&
    // birthDate?: string
    ( typeof arg.birthDate === 'undefined' || typeof arg.birthDate === 'string' ) &&
    // contractorSuppliedID?: string
    ( typeof arg.contractorSuppliedID === 'undefined' || typeof arg.contractorSuppliedID === 'string' ) &&
    // drivingLicence?: string
    ( typeof arg.drivingLicence === 'undefined' || typeof arg.drivingLicence === 'string' ) &&
    // groupId?: number
    ( typeof arg.groupId === 'undefined' || typeof arg.groupId === 'number' ) &&
    // groupName?: string
    ( typeof arg.groupName === 'undefined' || typeof arg.groupName === 'string' ) &&
    // healthServiceEndDate?: string
    ( typeof arg.healthServiceEndDate === 'undefined' || typeof arg.healthServiceEndDate === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // identityCard?: string
    ( typeof arg.identityCard === 'undefined' || typeof arg.identityCard === 'string' ) &&
    // insuredExternalId?: string
    ( typeof arg.insuredExternalId === 'undefined' || typeof arg.insuredExternalId === 'string' ) &&
    // isActive?: boolean
    ( typeof arg.isActive === 'undefined' || typeof arg.isActive === 'boolean' ) &&
    // koopFrameContractID?: string
    ( typeof arg.koopFrameContractID === 'undefined' || typeof arg.koopFrameContractID === 'string' ) &&
    // koopSubContractID?: string
    ( typeof arg.koopSubContractID === 'undefined' || typeof arg.koopSubContractID === 'string' ) &&
    // mothersName?: string
    ( typeof arg.mothersName === 'undefined' || typeof arg.mothersName === 'string' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // naturalPersonIsPassive?: boolean
    ( typeof arg.naturalPersonIsPassive === 'undefined' || typeof arg.naturalPersonIsPassive === 'boolean' ) &&
    // naturapPersonUId?: string
    ( typeof arg.naturapPersonUId === 'undefined' || typeof arg.naturapPersonUId === 'string' ) &&
    // offerNumber?: string
    ( typeof arg.offerNumber === 'undefined' || typeof arg.offerNumber === 'string' ) &&
    // passport?: string
    ( typeof arg.passport === 'undefined' || typeof arg.passport === 'string' ) &&
    // paymentEndDate?: string
    ( typeof arg.paymentEndDate === 'undefined' || typeof arg.paymentEndDate === 'string' ) &&
    // paymentStartDate?: string
    ( typeof arg.paymentStartDate === 'undefined' || typeof arg.paymentStartDate === 'string' ) &&
    // riskEndDate?: string
    ( typeof arg.riskEndDate === 'undefined' || typeof arg.riskEndDate === 'string' ) &&
    // riskStartDate?: string
    ( typeof arg.riskStartDate === 'undefined' || typeof arg.riskStartDate === 'string' ) &&
    // socialSecurityNumber?: string
    ( typeof arg.socialSecurityNumber === 'undefined' || typeof arg.socialSecurityNumber === 'string' ) &&
    // taxNumber?: string
    ( typeof arg.taxNumber === 'undefined' || typeof arg.taxNumber === 'string' ) &&

  true
  );
  }

export function isJWTDto(arg: any): arg is models.JWTDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // JWTToken?: string
    ( typeof arg.JWTToken === 'undefined' || typeof arg.JWTToken === 'string' ) &&

  true
  );
  }

export function isKompaktContractDto(arg: any): arg is models.KompaktContractDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // koopFrameContractID?: string
    ( typeof arg.koopFrameContractID === 'undefined' || typeof arg.koopFrameContractID === 'string' ) &&
    // koopProductId?: number
    ( typeof arg.koopProductId === 'undefined' || typeof arg.koopProductId === 'number' ) &&
    // offerNumber?: string
    ( typeof arg.offerNumber === 'undefined' || typeof arg.offerNumber === 'string' ) &&
    // signatoryName?: string
    ( typeof arg.signatoryName === 'undefined' || typeof arg.signatoryName === 'string' ) &&
    // state?: string
    ( typeof arg.state === 'undefined' || typeof arg.state === 'string' ) &&

  true
  );
  }

export function isLegalPersonDto(arg: any): arg is models.LegalPersonDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // companyAddress?: AddressDto
    ( typeof arg.companyAddress === 'undefined' || isAddressDto(arg.companyAddress) ) &&
    // companyName?: string
    ( typeof arg.companyName === 'undefined' || typeof arg.companyName === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // koopFrameContractID?: string
    ( typeof arg.koopFrameContractID === 'undefined' || typeof arg.koopFrameContractID === 'string' ) &&
    // koopPartnerID?: number
    ( typeof arg.koopPartnerID === 'undefined' || typeof arg.koopPartnerID === 'number' ) &&
    // mailingAddress?: AddressDto
    ( typeof arg.mailingAddress === 'undefined' || isAddressDto(arg.mailingAddress) ) &&
    // registrationNumber?: string
    ( typeof arg.registrationNumber === 'undefined' || typeof arg.registrationNumber === 'string' ) &&
    // taxNumber?: string
    ( typeof arg.taxNumber === 'undefined' || typeof arg.taxNumber === 'string' ) &&

  true
  );
  }

export function isManpowerReportDto(arg: any): arg is models.ManpowerReportDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // contractId?: number
    ( typeof arg.contractId === 'undefined' || typeof arg.contractId === 'number' ) &&
    // groupName?: string
    ( typeof arg.groupName === 'undefined' || typeof arg.groupName === 'string' ) &&
    // insuredPersonsQuantity?: number
    ( typeof arg.insuredPersonsQuantity === 'undefined' || typeof arg.insuredPersonsQuantity === 'number' ) &&
    // insuredPersonsQuantityByInsuredExternalId?: number
    ( typeof arg.insuredPersonsQuantityByInsuredExternalId === 'undefined' || typeof arg.insuredPersonsQuantityByInsuredExternalId === 'number' ) &&
    // koopFrameContractId?: string
    ( typeof arg.koopFrameContractId === 'undefined' || typeof arg.koopFrameContractId === 'string' ) &&
    // koopGroupName?: string
    ( typeof arg.koopGroupName === 'undefined' || typeof arg.koopGroupName === 'string' ) &&
    // koopInsuredPersonsQuantity?: number
    ( typeof arg.koopInsuredPersonsQuantity === 'undefined' || typeof arg.koopInsuredPersonsQuantity === 'number' ) &&
    // koopSubContractId?: string
    ( typeof arg.koopSubContractId === 'undefined' || typeof arg.koopSubContractId === 'string' ) &&
    // month?: number
    ( typeof arg.month === 'undefined' || typeof arg.month === 'number' ) &&
    // monthName?: string
    ( typeof arg.monthName === 'undefined' || typeof arg.monthName === 'string' ) &&
    // subContractId?: number
    ( typeof arg.subContractId === 'undefined' || typeof arg.subContractId === 'number' ) &&
    // year?: number
    ( typeof arg.year === 'undefined' || typeof arg.year === 'number' ) &&

  true
  );
  }

export function isMessageDto(arg: any): arg is models.MessageDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // message: string
    ( typeof arg.message === 'string' ) &&
    // subject: string
    ( typeof arg.subject === 'string' ) &&

  true
  );
  }

export function isNaturalPersonDto(arg: any): arg is models.NaturalPersonDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // administrationGroupId?: number
    ( typeof arg.administrationGroupId === 'undefined' || typeof arg.administrationGroupId === 'number' ) &&
    // anniversary?: string
    ( typeof arg.anniversary === 'undefined' || typeof arg.anniversary === 'string' ) &&
    // bankAccountNumber?: string
    ( typeof arg.bankAccountNumber === 'undefined' || typeof arg.bankAccountNumber === 'string' ) &&
    // birthDate?: string
    ( typeof arg.birthDate === 'undefined' || typeof arg.birthDate === 'string' ) &&
    // birthName?: string
    ( typeof arg.birthName === 'undefined' || typeof arg.birthName === 'string' ) &&
    // birthPlace?: string
    ( typeof arg.birthPlace === 'undefined' || typeof arg.birthPlace === 'string' ) &&
    // contractorData?: PersonDto
    ( typeof arg.contractorData === 'undefined' || isPersonDto(arg.contractorData) ) &&
    // contractorSuppliedID?: string
    ( typeof arg.contractorSuppliedID === 'undefined' || typeof arg.contractorSuppliedID === 'string' ) &&
    // createdBy?: string
    ( typeof arg.createdBy === 'undefined' || typeof arg.createdBy === 'string' ) &&
    // creationDate?: string
    ( typeof arg.creationDate === 'undefined' || typeof arg.creationDate === 'string' ) &&
    // drivingLicence?: string
    ( typeof arg.drivingLicence === 'undefined' || typeof arg.drivingLicence === 'string' ) &&
    // email?: string
    ( typeof arg.email === 'undefined' || typeof arg.email === 'string' ) &&
    // firstName?: string
    ( typeof arg.firstName === 'undefined' || typeof arg.firstName === 'string' ) &&
    // frameContractDeletionEffectDate?: string
    ( typeof arg.frameContractDeletionEffectDate === 'undefined' || typeof arg.frameContractDeletionEffectDate === 'string' ) &&
    // frameContractID?: number
    ( typeof arg.frameContractID === 'undefined' || typeof arg.frameContractID === 'number' ) &&
    // frameContractRiskEndDate?: string
    ( typeof arg.frameContractRiskEndDate === 'undefined' || typeof arg.frameContractRiskEndDate === 'string' ) &&
    // frameContractRiskStartDate?: string
    ( typeof arg.frameContractRiskStartDate === 'undefined' || typeof arg.frameContractRiskStartDate === 'string' ) &&
    // frameContractState?: CTStateDto
    ( typeof arg.frameContractState === 'undefined' || isCTStateDto(arg.frameContractState) ) &&
    // groupId?: number
    ( typeof arg.groupId === 'undefined' || typeof arg.groupId === 'number' ) &&
    // groupName?: string
    ( typeof arg.groupName === 'undefined' || typeof arg.groupName === 'string' ) &&
    // healthServiceAdmin?: string
    ( typeof arg.healthServiceAdmin === 'undefined' || typeof arg.healthServiceAdmin === 'string' ) &&
    // healthServiceEndDate?: string
    ( typeof arg.healthServiceEndDate === 'undefined' || typeof arg.healthServiceEndDate === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // identityCard?: string
    ( typeof arg.identityCard === 'undefined' || typeof arg.identityCard === 'string' ) &&
    // insuredExternalID?: string
    ( typeof arg.insuredExternalID === 'undefined' || typeof arg.insuredExternalID === 'string' ) &&
    // isActive?: boolean
    ( typeof arg.isActive === 'undefined' || typeof arg.isActive === 'boolean' ) &&
    // isFitpuli?: boolean
    ( typeof arg.isFitpuli === 'undefined' || typeof arg.isFitpuli === 'boolean' ) &&
    // isPassive?: boolean
    ( typeof arg.isPassive === 'undefined' || typeof arg.isPassive === 'boolean' ) &&
    // koopFrameContractID?: string
    ( typeof arg.koopFrameContractID === 'undefined' || typeof arg.koopFrameContractID === 'string' ) &&
    // koopPartnerID?: number
    ( typeof arg.koopPartnerID === 'undefined' || typeof arg.koopPartnerID === 'number' ) &&
    // koopSexID?: number
    ( typeof arg.koopSexID === 'undefined' || typeof arg.koopSexID === 'number' ) &&
    // koopSubContractID?: string
    ( typeof arg.koopSubContractID === 'undefined' || typeof arg.koopSubContractID === 'string' ) &&
    // lastModifiedDate?: string
    ( typeof arg.lastModifiedDate === 'undefined' || typeof arg.lastModifiedDate === 'string' ) &&
    // lastName?: string
    ( typeof arg.lastName === 'undefined' || typeof arg.lastName === 'string' ) &&
    // mailingAddress?: AddressDto
    ( typeof arg.mailingAddress === 'undefined' || isAddressDto(arg.mailingAddress) ) &&
    // memberID?: string
    ( typeof arg.memberID === 'undefined' || typeof arg.memberID === 'string' ) &&
    // mobileNumber?: string
    ( typeof arg.mobileNumber === 'undefined' || typeof arg.mobileNumber === 'string' ) &&
    // mothersName?: string
    ( typeof arg.mothersName === 'undefined' || typeof arg.mothersName === 'string' ) &&
    // naturalPersonUId?: string
    ( typeof arg.naturalPersonUId === 'undefined' || typeof arg.naturalPersonUId === 'string' ) &&
    // offerNumber?: string
    ( typeof arg.offerNumber === 'undefined' || typeof arg.offerNumber === 'string' ) &&
    // passport?: string
    ( typeof arg.passport === 'undefined' || typeof arg.passport === 'string' ) &&
    // paymentEndDate?: string
    ( typeof arg.paymentEndDate === 'undefined' || typeof arg.paymentEndDate === 'string' ) &&
    // paymentStartDate?: string
    ( typeof arg.paymentStartDate === 'undefined' || typeof arg.paymentStartDate === 'string' ) &&
    // permanentAddress?: AddressDto
    ( typeof arg.permanentAddress === 'undefined' || isAddressDto(arg.permanentAddress) ) &&
    // previousContractKoopContractId?: string
    ( typeof arg.previousContractKoopContractId === 'undefined' || typeof arg.previousContractKoopContractId === 'string' ) &&
    // previousContractKoopProductId?: number
    ( typeof arg.previousContractKoopProductId === 'undefined' || typeof arg.previousContractKoopProductId === 'number' ) &&
    // residencePermitNumber?: string
    ( typeof arg.residencePermitNumber === 'undefined' || typeof arg.residencePermitNumber === 'string' ) &&
    // riskEndDate?: string
    ( typeof arg.riskEndDate === 'undefined' || typeof arg.riskEndDate === 'string' ) &&
    // risks?: RiskDto[]
    ( typeof arg.risks === 'undefined' || (Array.isArray(arg.risks) && arg.risks.every((item: unknown) => isRiskDto(item))) ) &&
    // riskStartDate?: string
    ( typeof arg.riskStartDate === 'undefined' || typeof arg.riskStartDate === 'string' ) &&
    // sexID?: CTSexDto
    ( typeof arg.sexID === 'undefined' || isCTSexDto(arg.sexID) ) &&
    // socialSecurityNumber?: string
    ( typeof arg.socialSecurityNumber === 'undefined' || typeof arg.socialSecurityNumber === 'string' ) &&
    // subContractDeletionEffectDate?: string
    ( typeof arg.subContractDeletionEffectDate === 'undefined' || typeof arg.subContractDeletionEffectDate === 'string' ) &&
    // subContractID?: number
    ( typeof arg.subContractID === 'undefined' || typeof arg.subContractID === 'number' ) &&
    // subContractRiskEndDate?: string
    ( typeof arg.subContractRiskEndDate === 'undefined' || typeof arg.subContractRiskEndDate === 'string' ) &&
    // subContractRiskStartDate?: string
    ( typeof arg.subContractRiskStartDate === 'undefined' || typeof arg.subContractRiskStartDate === 'string' ) &&
    // subContractState?: CTStateDto
    ( typeof arg.subContractState === 'undefined' || isCTStateDto(arg.subContractState) ) &&
    // taxNumber?: string
    ( typeof arg.taxNumber === 'undefined' || typeof arg.taxNumber === 'string' ) &&
    // title?: string
    ( typeof arg.title === 'undefined' || typeof arg.title === 'string' ) &&
    // uFONaturalPersonID?: number
    ( typeof arg.uFONaturalPersonID === 'undefined' || typeof arg.uFONaturalPersonID === 'number' ) &&
    // VIP?: boolean
    ( typeof arg.VIP === 'undefined' || typeof arg.VIP === 'boolean' ) &&

  true
  );
  }

export function isPagedInsurantsSearchListItemDto(arg: any): arg is models.PagedInsurantsSearchListItemDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // data?: InsurantsSearchListItemDto[]
    ( typeof arg.data === 'undefined' || (Array.isArray(arg.data) && arg.data.every((item: unknown) => isInsurantsSearchListItemDto(item))) ) &&
    // meta?: FilteredSortedPagedDto
    ( typeof arg.meta === 'undefined' || isFilteredSortedPagedDto(arg.meta) ) &&

  true
  );
  }

export function isPagedNaturalPersonDto(arg: any): arg is models.PagedNaturalPersonDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // data?: NaturalPersonDto[]
    ( typeof arg.data === 'undefined' || (Array.isArray(arg.data) && arg.data.every((item: unknown) => isNaturalPersonDto(item))) ) &&
    // meta?: FilteredSortedPagedDto
    ( typeof arg.meta === 'undefined' || isFilteredSortedPagedDto(arg.meta) ) &&

  true
  );
  }

export function isPaginationDto(arg: any): arg is models.PaginationDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // currentPage?: number
    ( typeof arg.currentPage === 'undefined' || typeof arg.currentPage === 'number' ) &&
    // firstRowOnPage?: number
    ( typeof arg.firstRowOnPage === 'undefined' || typeof arg.firstRowOnPage === 'number' ) &&
    // lastRowOnPage?: number
    ( typeof arg.lastRowOnPage === 'undefined' || typeof arg.lastRowOnPage === 'number' ) &&
    // pageCount?: number
    ( typeof arg.pageCount === 'undefined' || typeof arg.pageCount === 'number' ) &&
    // pageSize?: number
    ( typeof arg.pageSize === 'undefined' || typeof arg.pageSize === 'number' ) &&
    // rowCount?: number
    ( typeof arg.rowCount === 'undefined' || typeof arg.rowCount === 'number' ) &&

  true
  );
  }

export function isPassiveContractAdministrationDto(arg: any): arg is models.PassiveContractAdministrationDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // connectionKey?: string
    ( typeof arg.connectionKey === 'undefined' || typeof arg.connectionKey === 'string' ) &&
    // connectionLink?: string
    ( typeof arg.connectionLink === 'undefined' || typeof arg.connectionLink === 'string' ) &&
    // createdAt?: string
    ( typeof arg.createdAt === 'undefined' || typeof arg.createdAt === 'string' ) &&
    // createdBy?: string
    ( typeof arg.createdBy === 'undefined' || typeof arg.createdBy === 'string' ) &&
    // customStartDate: number
    ( typeof arg.customStartDate === 'number' ) &&
    // displayNameInLink: string
    ( typeof arg.displayNameInLink === 'string' ) &&
    // documentsLink?: string
    ( typeof arg.documentsLink === 'undefined' || typeof arg.documentsLink === 'string' ) &&
    // getDocsByRisks?: boolean
    ( typeof arg.getDocsByRisks === 'undefined' || typeof arg.getDocsByRisks === 'boolean' ) &&
    // hasEnglishVersion?: boolean
    ( typeof arg.hasEnglishVersion === 'undefined' || typeof arg.hasEnglishVersion === 'boolean' ) &&
    // hipAgeLimitType?: CTHIPAgeLimitTypeDto
    ( typeof arg.hipAgeLimitType === 'undefined' || isCTHIPAgeLimitTypeDto(arg.hipAgeLimitType) ) &&
    // hipCustomerType?: CTHIPCustomerTypeDto
    ( typeof arg.hipCustomerType === 'undefined' || isCTHIPCustomerTypeDto(arg.hipCustomerType) ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // koopFrameContractId: string
    ( typeof arg.koopFrameContractId === 'string' ) &&
    // linkType: string
    ( typeof arg.linkType === 'string' ) &&
    // logo?: string
    ( typeof arg.logo === 'undefined' || typeof arg.logo === 'string' ) &&
    // originalFrameStartDate?: string
    ( typeof arg.originalFrameStartDate === 'undefined' || typeof arg.originalFrameStartDate === 'string' ) &&
    // validFrom?: string
    ( typeof arg.validFrom === 'undefined' || typeof arg.validFrom === 'string' ) &&
    // validTill?: string
    ( typeof arg.validTill === 'undefined' || typeof arg.validTill === 'string' ) &&

  true
  );
  }

export function isPasswordChangeDto(arg: any): arg is models.PasswordChangeDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // text?: string
    ( typeof arg.text === 'undefined' || typeof arg.text === 'string' ) &&
    // url?: string
    ( typeof arg.url === 'undefined' || typeof arg.url === 'string' ) &&

  true
  );
  }

export function isPaymentFrequencyDto(arg: any): arg is models.PaymentFrequencyDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // annually?: number
    ( typeof arg.annually === 'undefined' || typeof arg.annually === 'number' ) &&
    // monthly?: number
    ( typeof arg.monthly === 'undefined' || typeof arg.monthly === 'number' ) &&
    // quarterly?: number
    ( typeof arg.quarterly === 'undefined' || typeof arg.quarterly === 'number' ) &&
    // semiAnnually?: number
    ( typeof arg.semiAnnually === 'undefined' || typeof arg.semiAnnually === 'number' ) &&

  true
  );
  }

export function isPersonDto(arg: any): arg is models.PersonDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // legalPerson?: LegalPersonDto
    ( typeof arg.legalPerson === 'undefined' || isLegalPersonDto(arg.legalPerson) ) &&
    // naturalPerson?: NaturalPersonDto
    ( typeof arg.naturalPerson === 'undefined' || isNaturalPersonDto(arg.naturalPerson) ) &&

  true
  );
  }

export function isProfileDto(arg: any): arg is models.ProfileDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // emailAddress?: string
    ( typeof arg.emailAddress === 'undefined' || typeof arg.emailAddress === 'string' ) &&
    // givenName?: string
    ( typeof arg.givenName === 'undefined' || typeof arg.givenName === 'string' ) &&
    // roles?: string[]
    ( typeof arg.roles === 'undefined' || (Array.isArray(arg.roles) && arg.roles.every((item: unknown) => typeof item === 'string')) ) &&
    // sureName?: string
    ( typeof arg.sureName === 'undefined' || typeof arg.sureName === 'string' ) &&

  true
  );
  }

export function isRiskDto(arg: any): arg is models.RiskDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // createdBy?: string
    ( typeof arg.createdBy === 'undefined' || typeof arg.createdBy === 'string' ) &&
    // creationDate?: string
    ( typeof arg.creationDate === 'undefined' || typeof arg.creationDate === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // isActive?: boolean
    ( typeof arg.isActive === 'undefined' || typeof arg.isActive === 'boolean' ) &&
    // koopFrameContractID?: string
    ( typeof arg.koopFrameContractID === 'undefined' || typeof arg.koopFrameContractID === 'string' ) &&
    // koopProductID?: number
    ( typeof arg.koopProductID === 'undefined' || typeof arg.koopProductID === 'number' ) &&
    // koopRiskID?: number
    ( typeof arg.koopRiskID === 'undefined' || typeof arg.koopRiskID === 'number' ) &&
    // koopSubContractID?: string
    ( typeof arg.koopSubContractID === 'undefined' || typeof arg.koopSubContractID === 'string' ) &&
    // limitAmount?: number
    ( typeof arg.limitAmount === 'undefined' || typeof arg.limitAmount === 'number' ) &&
    // limitAmountString?: string
    ( typeof arg.limitAmountString === 'undefined' || typeof arg.limitAmountString === 'string' ) &&
    // limitQuantity?: number
    ( typeof arg.limitQuantity === 'undefined' || typeof arg.limitQuantity === 'number' ) &&
    // limitStartDate?: string
    ( typeof arg.limitStartDate === 'undefined' || typeof arg.limitStartDate === 'string' ) &&
    // name?: string
    ( typeof arg.name === 'undefined' || typeof arg.name === 'string' ) &&
    // preferredProvider?: string
    ( typeof arg.preferredProvider === 'undefined' || typeof arg.preferredProvider === 'string' ) &&
    // productType?: CTProductTypeDto
    ( typeof arg.productType === 'undefined' || isCTProductTypeDto(arg.productType) ) &&
    // remainingLimitAmount?: string
    ( typeof arg.remainingLimitAmount === 'undefined' || typeof arg.remainingLimitAmount === 'string' ) &&
    // subRisks?: RiskDto[]
    ( typeof arg.subRisks === 'undefined' || (Array.isArray(arg.subRisks) && arg.subRisks.every((item: unknown) => isRiskDto(item))) ) &&

  true
  );
  }

export function isSmartCubePDFGenerationResponseDto(arg: any): arg is models.SmartCubePDFGenerationResponseDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // code?: number
    ( typeof arg.code === 'undefined' || typeof arg.code === 'number' ) &&
    // message?: string
    ( typeof arg.message === 'undefined' || typeof arg.message === 'string' ) &&
    // msg?: string
    ( typeof arg.msg === 'undefined' || typeof arg.msg === 'string' ) &&
    // success: boolean
    ( typeof arg.success === 'boolean' ) &&

  true
  );
  }

export function isSortDto(arg: any): arg is models.SortDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // orderBy?: string
    ( typeof arg.orderBy === 'undefined' || typeof arg.orderBy === 'string' ) &&
    // sortOrder?: 'ASC' | 'DESC'
    ( typeof arg.sortOrder === 'undefined' || ['ASC', 'DESC'].includes(arg.sortOrder) ) &&

  true
  );
  }

export function isStringResponseDto(arg: any): arg is models.StringResponseDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // response?: string
    ( typeof arg.response === 'undefined' || typeof arg.response === 'string' ) &&

  true
  );
  }

export function isSubContractDto(arg: any): arg is models.SubContractDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // anniversary?: string
    ( typeof arg.anniversary === 'undefined' || typeof arg.anniversary === 'string' ) &&
    // averageAge?: number
    ( typeof arg.averageAge === 'undefined' || typeof arg.averageAge === 'number' ) &&
    // averageAgeCalculated?: number
    ( typeof arg.averageAgeCalculated === 'undefined' || typeof arg.averageAgeCalculated === 'number' ) &&
    // createdBy?: string
    ( typeof arg.createdBy === 'undefined' || typeof arg.createdBy === 'string' ) &&
    // creationDate?: string
    ( typeof arg.creationDate === 'undefined' || typeof arg.creationDate === 'string' ) &&
    // customizations?: CustomizationDto[]
    ( typeof arg.customizations === 'undefined' || (Array.isArray(arg.customizations) && arg.customizations.every((item: unknown) => isCustomizationDto(item))) ) &&
    // group?: GroupDto
    ( typeof arg.group === 'undefined' || isGroupDto(arg.group) ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // indexationMultiplier?: number
    ( typeof arg.indexationMultiplier === 'undefined' || typeof arg.indexationMultiplier === 'number' ) &&
    // indexationMultiplierPrev?: number
    ( typeof arg.indexationMultiplierPrev === 'undefined' || typeof arg.indexationMultiplierPrev === 'number' ) &&
    // indexationStartsAt?: string
    ( typeof arg.indexationStartsAt === 'undefined' || typeof arg.indexationStartsAt === 'string' ) &&
    // insuredPersonsQuantity?: number
    ( typeof arg.insuredPersonsQuantity === 'undefined' || typeof arg.insuredPersonsQuantity === 'number' ) &&
    // insuredPersonsQuantityCalculated?: number
    ( typeof arg.insuredPersonsQuantityCalculated === 'undefined' || typeof arg.insuredPersonsQuantityCalculated === 'number' ) &&
    // isActive?: boolean
    ( typeof arg.isActive === 'undefined' || typeof arg.isActive === 'boolean' ) &&
    // koopFrameContractID?: string
    ( typeof arg.koopFrameContractID === 'undefined' || typeof arg.koopFrameContractID === 'string' ) &&
    // koopGroupID?: string
    ( typeof arg.koopGroupID === 'undefined' || typeof arg.koopGroupID === 'string' ) &&
    // koopPaymentFreqID?: string
    ( typeof arg.koopPaymentFreqID === 'undefined' || typeof arg.koopPaymentFreqID === 'string' ) &&
    // koopPaymentTypeID?: string
    ( typeof arg.koopPaymentTypeID === 'undefined' || typeof arg.koopPaymentTypeID === 'string' ) &&
    // koopStateID?: string
    ( typeof arg.koopStateID === 'undefined' || typeof arg.koopStateID === 'string' ) &&
    // koopSubContractID?: string
    ( typeof arg.koopSubContractID === 'undefined' || typeof arg.koopSubContractID === 'string' ) &&
    // paymentFreq?: CTPaymentFreqDto
    ( typeof arg.paymentFreq === 'undefined' || isCTPaymentFreqDto(arg.paymentFreq) ) &&
    // paymentType?: CTPaymentTypeDto
    ( typeof arg.paymentType === 'undefined' || isCTPaymentTypeDto(arg.paymentType) ) &&
    // preferredProvider?: string
    ( typeof arg.preferredProvider === 'undefined' || typeof arg.preferredProvider === 'string' ) &&
    // productMarketingName?: string
    ( typeof arg.productMarketingName === 'undefined' || typeof arg.productMarketingName === 'string' ) &&
    // riskEndDate?: string
    ( typeof arg.riskEndDate === 'undefined' || typeof arg.riskEndDate === 'string' ) &&
    // riskStartDate?: string
    ( typeof arg.riskStartDate === 'undefined' || typeof arg.riskStartDate === 'string' ) &&
    // state?: CTStateDto
    ( typeof arg.state === 'undefined' || isCTStateDto(arg.state) ) &&
    // variantID?: string
    ( typeof arg.variantID === 'undefined' || typeof arg.variantID === 'string' ) &&

  true
  );
  }

export function isSyncLogDetailedDto(arg: any): arg is models.SyncLogDetailedDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // contract?: ContractDto
    ( typeof arg.contract === 'undefined' || isContractDto(arg.contract) ) &&
    // createdAt?: string
    ( typeof arg.createdAt === 'undefined' || typeof arg.createdAt === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // koopCreationDate?: string
    ( typeof arg.koopCreationDate === 'undefined' || typeof arg.koopCreationDate === 'string' ) &&
    // koopFrameContractID?: string
    ( typeof arg.koopFrameContractID === 'undefined' || typeof arg.koopFrameContractID === 'string' ) &&
    // koopHistoryNumber?: number
    ( typeof arg.koopHistoryNumber === 'undefined' || typeof arg.koopHistoryNumber === 'number' ) &&
    // koopSubContractID?: string
    ( typeof arg.koopSubContractID === 'undefined' || typeof arg.koopSubContractID === 'string' ) &&
    // new_Val?: string
    ( typeof arg.new_Val === 'undefined' || typeof arg.new_Val === 'string' ) &&
    // offerNumber?: string
    ( typeof arg.offerNumber === 'undefined' || typeof arg.offerNumber === 'string' ) &&
    // old_Val?: string
    ( typeof arg.old_Val === 'undefined' || typeof arg.old_Val === 'string' ) &&
    // subContract?: SubContractDto
    ( typeof arg.subContract === 'undefined' || isSubContractDto(arg.subContract) ) &&
    // syncLog?: SyncLogDto
    ( typeof arg.syncLog === 'undefined' || isSyncLogDto(arg.syncLog) ) &&
    // zm_fld?: string
    ( typeof arg.zm_fld === 'undefined' || typeof arg.zm_fld === 'string' ) &&
    // zm_ID?: string
    ( typeof arg.zm_ID === 'undefined' || typeof arg.zm_ID === 'string' ) &&
    // zm_Tab?: string
    ( typeof arg.zm_Tab === 'undefined' || typeof arg.zm_Tab === 'string' ) &&

  true
  );
  }

export function isSyncLogDto(arg: any): arg is models.SyncLogDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // createdAt?: string
    ( typeof arg.createdAt === 'undefined' || typeof arg.createdAt === 'string' ) &&
    // deatails?: string
    ( typeof arg.deatails === 'undefined' || typeof arg.deatails === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // isSuccess?: boolean
    ( typeof arg.isSuccess === 'undefined' || typeof arg.isSuccess === 'boolean' ) &&
    // message?: string
    ( typeof arg.message === 'undefined' || typeof arg.message === 'string' ) &&
    // processType?: CTProcessTypeDto
    ( typeof arg.processType === 'undefined' || isCTProcessTypeDto(arg.processType) ) &&

  true
  );
  }

export function isSystemSettingsDto(arg: any): arg is models.SystemSettingsDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // environment?: string
    ( typeof arg.environment === 'undefined' || typeof arg.environment === 'string' ) &&
    // locale?: string
    ( typeof arg.locale === 'undefined' || typeof arg.locale === 'string' ) &&
    // sso?: SystemSSOSettingsDto
    ( typeof arg.sso === 'undefined' || isSystemSSOSettingsDto(arg.sso) ) &&
    // syncData?: SystemSyncDataDto
    ( typeof arg.syncData === 'undefined' || isSystemSyncDataDto(arg.syncData) ) &&
    // version?: string
    ( typeof arg.version === 'undefined' || typeof arg.version === 'string' ) &&

  true
  );
  }

export function isSystemSSOSettingsDto(arg: any): arg is models.SystemSSOSettingsDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // appCode?: string
    ( typeof arg.appCode === 'undefined' || typeof arg.appCode === 'string' ) &&
    // samlSloUrl?: string
    ( typeof arg.samlSloUrl === 'undefined' || typeof arg.samlSloUrl === 'string' ) &&
    // samlSsoUrl?: string
    ( typeof arg.samlSsoUrl === 'undefined' || typeof arg.samlSsoUrl === 'string' ) &&
    // timeoutMinutes?: number
    ( typeof arg.timeoutMinutes === 'undefined' || typeof arg.timeoutMinutes === 'number' ) &&

  true
  );
  }

export function isSystemSyncDataDto(arg: any): arg is models.SystemSyncDataDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // lastContractSyncDate?: string
    ( typeof arg.lastContractSyncDate === 'undefined' || typeof arg.lastContractSyncDate === 'string' ) &&
    // lastInsurantsSyncToHealthServiceDate?: string
    ( typeof arg.lastInsurantsSyncToHealthServiceDate === 'undefined' || typeof arg.lastInsurantsSyncToHealthServiceDate === 'string' ) &&
    // lastUploadProcessDate?: string
    ( typeof arg.lastUploadProcessDate === 'undefined' || typeof arg.lastUploadProcessDate === 'string' ) &&

  true
  );
  }

export function isTransferLogDto(arg: any): arg is models.TransferLogDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // contractNumber?: string
    ( typeof arg.contractNumber === 'undefined' || typeof arg.contractNumber === 'string' ) &&
    // errorMsg?: string
    ( typeof arg.errorMsg === 'undefined' || typeof arg.errorMsg === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // isSuccess?: boolean
    ( typeof arg.isSuccess === 'undefined' || typeof arg.isSuccess === 'boolean' ) &&
    // processID?: string
    ( typeof arg.processID === 'undefined' || typeof arg.processID === 'string' ) &&
    // processType?: CTProcessTypeDto
    ( typeof arg.processType === 'undefined' || isCTProcessTypeDto(arg.processType) ) &&
    // productType?: CTProductTypeDto
    ( typeof arg.productType === 'undefined' || isCTProductTypeDto(arg.productType) ) &&
    // transferDate?: string
    ( typeof arg.transferDate === 'undefined' || typeof arg.transferDate === 'string' ) &&
    // uploadID?: number
    ( typeof arg.uploadID === 'undefined' || typeof arg.uploadID === 'number' ) &&

  true
  );
  }

export function isUFOFileInfoResultDto(arg: any): arg is models.UFOFileInfoResultDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // createDate?: string
    ( typeof arg.createDate === 'undefined' || typeof arg.createDate === 'string' ) &&
    // errorCode?: string
    ( typeof arg.errorCode === 'undefined' || typeof arg.errorCode === 'string' ) &&
    // errorMessage?: string
    ( typeof arg.errorMessage === 'undefined' || typeof arg.errorMessage === 'string' ) &&
    // expiryDate?: string
    ( typeof arg.expiryDate === 'undefined' || typeof arg.expiryDate === 'string' ) &&
    // fileFormat?: string
    ( typeof arg.fileFormat === 'undefined' || typeof arg.fileFormat === 'string' ) &&
    // fileName?: string
    ( typeof arg.fileName === 'undefined' || typeof arg.fileName === 'string' ) &&
    // filePath?: string
    ( typeof arg.filePath === 'undefined' || typeof arg.filePath === 'string' ) &&
    // fileSize?: number
    ( typeof arg.fileSize === 'undefined' || typeof arg.fileSize === 'number' ) &&
    // fileVersion?: string
    ( typeof arg.fileVersion === 'undefined' || typeof arg.fileVersion === 'string' ) &&
    // fpw?: string
    ( typeof arg.fpw === 'undefined' || typeof arg.fpw === 'string' ) &&
    // ip?: string
    ( typeof arg.ip === 'undefined' || typeof arg.ip === 'string' ) &&
    // loadFormat?: string
    ( typeof arg.loadFormat === 'undefined' || typeof arg.loadFormat === 'string' ) &&
    // productName?: string
    ( typeof arg.productName === 'undefined' || typeof arg.productName === 'string' ) &&
    // recordCount?: number
    ( typeof arg.recordCount === 'undefined' || typeof arg.recordCount === 'number' ) &&
    // structureVersion?: string
    ( typeof arg.structureVersion === 'undefined' || typeof arg.structureVersion === 'string' ) &&
    // success?: boolean
    ( typeof arg.success === 'undefined' || typeof arg.success === 'boolean' ) &&
    // uploadFileID?: number
    ( typeof arg.uploadFileID === 'undefined' || typeof arg.uploadFileID === 'number' ) &&

  true
  );
  }

export function isUFOTransferLogDto(arg: any): arg is models.UFOTransferLogDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // errNum?: number
    ( typeof arg.errNum === 'undefined' || typeof arg.errNum === 'number' ) &&
    // errorMessage?: string
    ( typeof arg.errorMessage === 'undefined' || typeof arg.errorMessage === 'string' ) &&
    // iD?: number
    ( typeof arg.iD === 'undefined' || typeof arg.iD === 'number' ) &&
    // isSuccess?: boolean
    ( typeof arg.isSuccess === 'undefined' || typeof arg.isSuccess === 'boolean' ) &&
    // processID?: string
    ( typeof arg.processID === 'undefined' || typeof arg.processID === 'string' ) &&
    // retryToDate?: string
    ( typeof arg.retryToDate === 'undefined' || typeof arg.retryToDate === 'string' ) &&
    // transferDate?: string
    ( typeof arg.transferDate === 'undefined' || typeof arg.transferDate === 'string' ) &&
    // uFOContractNumber?: string
    ( typeof arg.uFOContractNumber === 'undefined' || typeof arg.uFOContractNumber === 'string' ) &&
    // uFOFileUploadID?: number
    ( typeof arg.uFOFileUploadID === 'undefined' || typeof arg.uFOFileUploadID === 'number' ) &&
    // uFOKoopGroupID?: string
    ( typeof arg.uFOKoopGroupID === 'undefined' || typeof arg.uFOKoopGroupID === 'string' ) &&
    // uFONaturalPersonID?: number
    ( typeof arg.uFONaturalPersonID === 'undefined' || typeof arg.uFONaturalPersonID === 'number' ) &&

  true
  );
  }

export function isUserDetailsDto(arg: any): arg is models.UserDetailsDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // contracts?: ContractSearchListItemDto[]
    ( typeof arg.contracts === 'undefined' || (Array.isArray(arg.contracts) && arg.contracts.every((item: unknown) => isContractSearchListItemDto(item))) ) &&
    // user?: CirUserDto
    ( typeof arg.user === 'undefined' || isCirUserDto(arg.user) ) &&

  true
  );
  }

export function isValidatedNaturalPersonDto(arg: any): arg is models.ValidatedNaturalPersonDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // insurantsData?: NaturalPersonDto
    ( typeof arg.insurantsData === 'undefined' || isNaturalPersonDto(arg.insurantsData) ) &&
    // validationData?: ValidationErrorDto
    ( typeof arg.validationData === 'undefined' || isValidationErrorDto(arg.validationData) ) &&

  true
  );
  }

export function isValidationErrorDto(arg: any): arg is models.ValidationErrorDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // code?: number
    ( typeof arg.code === 'undefined' || typeof arg.code === 'number' ) &&
    // message?: string
    ( typeof arg.message === 'undefined' || typeof arg.message === 'string' ) &&
    // validationErrors?: ValidationErrorItemDto[]
    ( typeof arg.validationErrors === 'undefined' || (Array.isArray(arg.validationErrors) && arg.validationErrors.every((item: unknown) => isValidationErrorItemDto(item))) ) &&

  true
  );
  }

export function isValidationErrorItemDto(arg: any): arg is models.ValidationErrorItemDto {
  return (
  arg != null &&
  typeof arg === 'object' &&
    // attemptedValue?: object
    ( typeof arg.attemptedValue === 'undefined' || typeof arg.attemptedValue === 'object' ) &&
    // errorCode?: string
    ( typeof arg.errorCode === 'undefined' || typeof arg.errorCode === 'string' ) &&
    // errorMessage?: string
    ( typeof arg.errorMessage === 'undefined' || typeof arg.errorMessage === 'string' ) &&
    // formattedMessagePlaceholderValues?: FormattedMessagePlaceholderValuesDto
    ( typeof arg.formattedMessagePlaceholderValues === 'undefined' || isFormattedMessagePlaceholderValuesDto(arg.formattedMessagePlaceholderValues) ) &&
    // propertyName?: string
    ( typeof arg.propertyName === 'undefined' || typeof arg.propertyName === 'string' ) &&
    // severity?: string
    ( typeof arg.severity === 'undefined' || typeof arg.severity === 'string' ) &&

  true
  );
  }


